import { APP_CONSTANTS } from 'src/consumer/constants'

export function buildPublicSessionJoinLink(sessionSlug) {
  if (!sessionSlug) {
    return ''
  }
  return `${APP_CONSTANTS.LIVE_APP_URL}/v/${sessionSlug}`
}

// Keep this only for explicit social-preview/bot flows that must hit the server-rendered
// share page first. Do not use this helper for patient-facing UI, copy actions, or WhatsApp
// delivery, which should always use the canonical /v/:sessionSlug link.
export function buildPublicSessionShareLink(sessionSlug) {
  if (!sessionSlug) {
    return ''
  }
  return `${APP_CONSTANTS.SOCIAL_SHARE_BASE_URL}/share/public-video-session/${sessionSlug}`
}
